export const LOGINLEFTBOTTOM = `
<svg viewBox="0 0 140 190" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组</title>
    <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
            <stop stop-color="currentColor" offset="0%"></stop>
            <stop stop-color="currentColor" stop-opacity="0.330009834" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="登录切图" transform="translate(-10.000000, -813.000000)">
            <g id="编组" transform="translate(99.000000, 892.000000) rotate(119.000000) translate(-99.000000, -892.000000) translate(20.000000, 808.000000)">
                <polyline id="路径-3" stroke="currentColor" stroke-width="6" opacity="0.300000012" stroke-linecap="round" stroke-linejoin="round" points="88.8121714 141 21.2931554 85.2417582 131.293155 23"></polyline>
                <circle id="椭圆形" fill="url(#linearGradient-1)" opacity="0.400000006" cx="140" cy="18" r="18"></circle>
                <circle id="椭圆形备份-2" fill="url(#linearGradient-1)" opacity="0.400000006" cx="100" cy="150" r="18"></circle>
                <circle id="椭圆形备份-3" fill="url(#linearGradient-1)" opacity="0.400000006" cx="18" cy="84" r="18"></circle>
            </g>
        </g>
    </g>
</svg>`;

export const LOGINLEFTTOP = `
<svg width="86px" height="86px" viewBox="0 0 86 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组</title>
    <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
            <stop stop-color="currentColor" offset="0%"></stop>
            <stop stop-color="currentColor" stop-opacity="0.330009834" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="登录切图" transform="translate(-114.000000, -152.000000)">
            <g id="编组-7" transform="translate(114.000000, 152.000000)">
                <g id="编组" transform="translate(3.000000, 1.000000)">
                    <polyline id="路径-3" stroke="currentColor" stroke-width="3" opacity="0.300000012" stroke-linecap="round" stroke-linejoin="round" points="44.4060857 70.5 10.6465777 42.6208791 65.6465777 11.5"></polyline>
                    <circle id="椭圆形" fill="url(#linearGradient-1)" opacity="0.400000006" cx="70" cy="9" r="9"></circle>
                    <circle id="椭圆形备份-2" fill="url(#linearGradient-1)" opacity="0.400000006" cx="50" cy="75" r="9"></circle>
                    <circle id="椭圆形备份-3" fill="url(#linearGradient-1)" opacity="0.400000006" cx="9" cy="42" r="9"></circle>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const LOGINRIGHTBOTTOM = `
<svg width="100px" height="100px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组备份</title>
    <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
            <stop stop-color="currentColor" offset="0%"></stop>
            <stop stop-color="currentColor" stop-opacity="0.330009834" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="登录切图" transform="translate(-1637.000000, -884.000000)">
            <g id="编组备份" transform="translate(1697.500000, 932.000000) rotate(-120.000000) translate(-1697.500000, -932.000000) translate(1658.000000, 890.000000)">
                <polyline id="路径-3" stroke="currentColor" stroke-width="3" opacity="0.300000012" stroke-linecap="round" stroke-linejoin="round" points="44.4060857 70.5 10.6465777 42.6208791 65.6465777 11.5"></polyline>
                <circle id="椭圆形" fill="url(#linearGradient-1)" opacity="0.400000006" cx="70" cy="9" r="9"></circle>
                <circle id="椭圆形备份-2" fill="url(#linearGradient-1)" opacity="0.400000006" cx="50" cy="75" r="9"></circle>
                <circle id="椭圆形备份-3" fill="url(#linearGradient-1)" opacity="0.400000006" cx="9" cy="42" r="9"></circle>
            </g>
        </g>
    </g>
</svg>
`;
